import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styles from "./ChartGranularity.css";
import * as actionCreators from "../../../store/analytics/chart-granularity/action-creators";
import _Aux from "../../_Aux";
import { WHITEBOARD_INITIAL_STATE, STORAGE_KEY_HOLIDAYSTITLE } from "../../../services/managers/constants";
import webStorageManager from "../../../services/managers/web-storage";

class ChartGranularity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExcludeHolidays: WHITEBOARD_INITIAL_STATE.isExcludeHolidays
    };
  }

  render() {
    let granularitiesDoc = this.props.granularities.map((granularity) => (
      <span
        className={
          styles.granularity +
          " " +
          (granularity.Code === this.props.selectedGranularity ? styles.highlight : "") +
          " " +
          (granularity.isEnabled ? "" : styles.unclickable)
        }
        key={granularity.Code}
        title={granularity.Tooltip}
        onClick={() => (granularity.isEnabled ? this.props.onSelectedGranularityChange(this.props.whiteboardIndex, granularity.Code, this.state.isExcludeHolidays) : false)}>
        {granularity.Name}
      </span>
    ));

    this.handleExcludeHolidaysChange = (event) => {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      this.setState({
        isExcludeHolidays: value
      }, () => this.props.onSelectedGranularityChange(this.props.whiteboardIndex, this.props.selectedGranularity, this.state.isExcludeHolidays));
    };

    const excludeDays = webStorageManager.get(STORAGE_KEY_HOLIDAYSTITLE).join(", ");

    return <_Aux>
      {granularitiesDoc}
      <div className={"toggle " + styles.holidayToggleBtn}>
        <input id={"switch4" + this.props.whiteboardIndex} type="checkbox" checked={this.state.isExcludeHolidays} onChange={this.handleExcludeHolidaysChange} />
        <label htmlFor={"switch4" + this.props.whiteboardIndex} className="toggle__label toggle__label-after disable_user_select"
        title={excludeDays}>
          Exclude Holidays
        </label>
      </div>
    </_Aux>;
  }
}

ChartGranularity.propTypes = {
  whiteboardIndex: PropTypes.number.isRequired,
  granularities: PropTypes.array.isRequired,
  selectedGranularity: PropTypes.string.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  onSelectedGranularityChange: (whiteboardIndex, code, isExcludeHolidays) => dispatch(actionCreators.onSelectedGranularityChange({ whiteboardIndex, code, isExcludeHolidays }))
});

export default connect(null, mapDispatchToProps)(ChartGranularity);



// WEBPACK FOOTER //
// ./src/components/Analytics/ChartGranularity/ChartGranularity.js